export enum AuthorizationEndpoints {
  Signup = 'signup',
  Login = 'login',
}
